export const APP_LOADED_DATE = new Date();

const LOCAL_STORAGE_PREFIX = "admin-center" as const;

function createLocalStorageKey<T extends string>(
  key: T,
): `${typeof LOCAL_STORAGE_PREFIX}-${T}` {
  return `${LOCAL_STORAGE_PREFIX}-${key}`;
}

/* Authorization bearer token key in localStorage */
export const LOCAL_STORAGE_AUTH_TOKEN_KEY = createLocalStorageKey("token");
export const LOCAL_STORAGE_FEATURE_FLAG = createLocalStorageKey("featureFlag");
export const LOCAL_STORAGE_I18NEXT = createLocalStorageKey("i18nextLng");
export const LOCAL_STORAGE_SIDEBAR_COLLAPSED =
  createLocalStorageKey("sidebarCollapsed");

export const INPUT_NUMBER_PREVENT_KEY = ["=", "-", ".", "+", "e"];

export const GLOBAL_SEARCH_PARAM_FEATURE_FLAG = "featureFlag";
export const GLOBAL_SEARCH_PARAM_I18NEXT = "lang";

// Shared placeholders
export const EMPTY_STRING_PLACEHOLDER = "－";
export const NBSP = "\u00A0";

// Magic number
export const KB = 1024;
export const MB = 1024 * KB;
export const GB = 1024 * MB;

/**
 * The platform's product name, shown in the side menu header and used in copy.
 * It is a brand name and stays in English in every locale.
 */
export const PLATFORM_NAME = "Crescendo Lab Platform";
